import modules_xls from './xls/index.js'
import modules_settings from './settings/index.js'
import modules_select from './select/index.js'
import modules_list from './list/index.js'
import modules_item from './item/index.js'
import modules_form from './form/index.js'
import modules_balance from './balance/index.js'
import _actions_search from './_actions/search.js'
import _actions_remove from './_actions/remove.js'
import _actions_filter from './_actions/filter.js'
import _actions_create from './_actions/create.js'
import _mutations_loading from './_mutations/loading.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        loading: _mutations_loading,
    },
    actions:{
        create: _actions_create,
        filter: _actions_filter,
        remove: _actions_remove,
        search: _actions_search,
    },
    modules:{
        balance: modules_balance,
        form: modules_form,
        item: modules_item,
        list: modules_list,
        select: modules_select,
        settings: modules_settings,
        xls: modules_xls,
    },
}